import { render, staticRenderFns } from "./team-achievement.vue?vue&type=template&id=5baaa412&"
import script from "./team-achievement.vue?vue&type=script&lang=js&"
export * from "./team-achievement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports